import { PayloadAction, createSlice } from "@reduxjs/toolkit";


export const selectedRecordSlice = createSlice({
    name: 'selectedRecord',
    initialState: {
        recordId: undefined
    } as { recordId: string | undefined },
    reducers: {
        setRecordId: (state, action: PayloadAction<{recordId: string}>) => {
            state.recordId= action.payload.recordId
        },
        cleanRecordId: (state) => {
            state.recordId = undefined
        }
    },
})

export const { setRecordId, cleanRecordId } = selectedRecordSlice.actions
export default selectedRecordSlice.reducer